const number = value => Number(String(value).trim().replace(',', '.'));
const ratio = (quantity, step) => {
  const value = quantity / step;
  const integer = Math.round(value);
  return Math.abs(value - integer) < 1e-8 ? integer : value;
};
const rounded = value => Math.round(value * 1e8) / 1e8;

export function normalizeCartQuantity(quantity, step = 1) {
  const amount = number(quantity), size = number(step);
  if (!Number.isFinite(amount) || !Number.isFinite(size) || size <= 0) return null;
  if (amount <= 0) return 0;
  return rounded(Math.ceil(ratio(amount, size)) * size);
}

export function nextCartQuantity(quantity, step = 1, direction = 1) {
  const amount = number(quantity), size = number(step);
  if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(size) || size <= 0) return null;
  const packs = direction > 0 ? Math.floor(ratio(amount, size)) + 1 : Math.ceil(ratio(amount, size)) - 1;
  return rounded(Math.max(0, packs) * size);
}

export function cartonCount(quantity, size) {
  const amount = number(quantity), carton = number(size);
  return Number.isFinite(amount) && Number.isFinite(carton) && carton > 0 ? rounded(ratio(amount, carton)) : null;
}
